import React from "react";
import { Doughnut } from "react-chartjs-2";
import "chart.js/auto";

/* Presentation only — the incoming `chartData` is never mutated. */

const PALETTE = [
  "#1c4f86", "#2b8fe0", "#0f9d63", "#19b87a",
  "#f59331", "#6d4bb8", "#63c8ff", "#4fdca4",
];

/* Fills the hole in the middle with the running total, which is the one
   number the ring itself cannot show. */
const centerTotal = {
  id: "centerTotal",
  afterDatasetsDraw(chart) {
    const arc = chart.getDatasetMeta(0)?.data?.[0];
    if (!arc) return;

    const values = chart.data?.datasets?.[0]?.data || [];
    const total = values.reduce((sum, v) => sum + (Number(v) || 0), 0);

    const { ctx } = chart;
    ctx.save();
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";

    ctx.fillStyle = "#1e293b";
    ctx.font = "700 28px Figtree, sans-serif";
    ctx.fillText(String(total), arc.x, arc.y - 7);

    ctx.fillStyle = "#94a3b8";
    ctx.font = "700 10.5px Figtree, sans-serif";
    ctx.fillText("TOTAL", arc.x, arc.y + 15);

    ctx.restore();
  },
};

const Piechart = (props) => {
  const source = props.chartData || { labels: [], datasets: [] };

  const data = {
    labels: source.labels,
    datasets: (source.datasets || []).map((set) => ({
      ...set,
      backgroundColor: PALETTE,
      borderColor: "#ffffff",
      borderWidth: 3,
      borderRadius: 10,
      hoverOffset: 12,
      hoverBorderColor: "#ffffff",
      spacing: 3,
    })),
  };

  return (
    <div className="pie-wrap">
      <Doughnut
        data={data}
        plugins={[centerTotal]}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          cutout: "70%",
          radius: "92%",
          animation: { animateRotate: true, animateScale: false, duration: 1000, easing: "easeOutQuart" },
          layout: { padding: 4 },
          plugins: {
            legend: {
              display: true,
              position: "bottom",
              labels: {
                usePointStyle: true,
                pointStyle: "circle",
                boxWidth: 8,
                boxHeight: 8,
                padding: 14,
                color: "#64748b",
                font: { family: "Figtree, sans-serif", size: 12, weight: "600" },
              },
            },
            tooltip: {
              backgroundColor: "#1e293b",
              padding: 12,
              cornerRadius: 12,
              usePointStyle: true,
              boxPadding: 6,
              titleColor: "#ffffff",
              titleFont: { family: "Figtree, sans-serif", size: 13, weight: "700" },
              bodyColor: "rgba(234,242,251,0.82)",
              bodyFont: { family: "Figtree, sans-serif", size: 12.5 },
            },
          },
        }}
      />
    </div>
  );
}

export default Piechart;
